import { render, staticRenderFns } from "./SingleColorPlanetSlide.vue?vue&type=template&id=0f82b971&scoped=true"
import script from "./SingleColorPlanetSlide.vue?vue&type=script&lang=js"
export * from "./SingleColorPlanetSlide.vue?vue&type=script&lang=js"
import style0 from "./SingleColorPlanetSlide.vue?vue&type=style&index=0&id=0f82b971&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f82b971",
  null
  
)

export default component.exports